import { addAdvertisingParameters, getAdvertisingParameters } from './advertisingAttribution.js';

const processLinks = (browser = window) => {
  const { document } = browser;
  const parameters = getAdvertisingParameters(browser);
  if (!Object.keys(parameters).length) return () => {};
  const updateLink = (link) => {
    const href = link.getAttribute('href');
    const updated = addAdvertisingParameters(href, parameters, document.baseURI);
    if (updated !== href) link.setAttribute('href', updated);
  };
  const updateTree = (root) => {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  };
  updateTree(document);

  // Also cover CMS widgets and links created after initial rendering.
  const observer = new browser.MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') updateTree(record.target);
      else record.addedNodes.forEach(updateTree);
    });
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });

  const onClick = (event) => {
    const link = event.target.closest?.('a[href]');
    if (link) updateLink(link);
  };
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  return () => {
    observer.disconnect();
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('auxclick', onClick, true);
  };
};

export default processLinks;
